<script>
	import {push} from "svelte-spa-router";
	import {onMount} from "svelte";
	import Data from "../controladores/data.svelte";
	import {documentos} from "../controladores/store.js";
	export let params;
	let controlador;
	let nombre = "",especie = "",raza = "",detalle = "",tamano = "",peso = 0,ano = 0, meses = 0,owner = "";
	onMount(()=>{
		if (params.cliente){
			owner = params.cliente;
		}
	})
	function volver(){
		push("/home");
	}
	async function agregar(){
		let cant = $documentos.filter((el)=>el.tipo == "mascota").length;
		let letra = especie.charAt(0);
		let doc = `${cant}${letra}`;
		let fecha = new Date();
		fecha.setMonth(fecha.getMonth() - meses);
		controlador.agregarMascota(doc,nombre,especie,raza,detalle,peso,tamano,fecha,owner);
	}
</script>
<Data bind:this={controlador} />
<div class="flex flex-col items-center justify-start bg-purple-300 w-screen h-full max-w-full min-h-screen">
	<h1 class="text-xl font-bold">Agregar Mascota</h1>
	<div class="flex flex-col items-center justify-start w-3/4 h-auto">
		<input bind:value={nombre} class="full p-2 m-4 w-full" placeholder="Nombre"/>
		<input  bind:value={especie} class="full p-2 m-4 w-full" placeholder="Especie"/>
		<input  bind:value={raza} class="full p-2 m-4 w-full" placeholder="Raza"/>
		<input bind:value={detalle} class="full p-2 m-4 w-full" placeholder="Observaciones"/>
		<select bind:value={tamano} class="full p-2 m-4 w-full">
			<option>Elegir Tamaño</option>
			<option value="Pequeño">Pequeño</option>
			<option value="Chico">Chico</option>
			<option value="Mediano">Mediano</option>
			<option value="Grande">Grande</option>
			<option value="Gigante">Gigante</option>
		</select>
		<div class="flex w-full items-center justify-around">
			<span>Edad(meses)</span>	
			<input bind:value={meses} type="number" placeholder="Meses de edad" />
		</div>
		<input bind:value={owner} class="full p-2 m-4 w-full" type="text" placeholder="Documento del  dueño" />
		<div class="flex w-full items-center justify-around">
			<button class="p-2 m-4 bg-purple-500 text-white flex items-center justify-center rounded" on:click={volver}>Volver</button>
			<button on:click={agregar} class="p-2 m-4 bg-purple-500 text-white flex items-center justify-center rounded">Agregar</button>
		</div>
	</div>
</div>
